'use strict';
const uploadFile = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	inputElement: document.querySelector('.contact-form__file-wrap input[type="file"]'),
	fileNameElement: document.querySelector('.js-upload-label'),
	outerWrapper: document.querySelector('.js-apply-upload-wrap'),
	wrapper: document.querySelector('.js-apply-upload-wrap .wpcf7-form-control-wrap'),
	removeIcon: document.querySelector('.js-contact-form-file-icon'),
	fileErrorMessage: document.querySelector('.js-file-formats'),


	/** @description Initialize */
	init: function() {
		if (!uploadFile.fileNameElement) return;
		this.titlePlacement();
		this.placeholderChange();
		this.removeFile();
	},

	titlePlacement: function() {
		const getLabel = uploadFile.outerWrapper.querySelector('.contact-form__file-input-label-upload');
		getLabel.remove();
		uploadFile.wrapper.appendChild(getLabel);
	},

	placeholderChange: function() {
		const changeEvent = new Event('change', {
			bubbles: true
		});

		uploadFile.inputElement.addEventListener('dragover', (event) => {
			event.preventDefault();
			uploadFile.inputElement.classList.add('active');
		});

		uploadFile.inputElement.addEventListener('dragleave', (event) => {
			event.preventDefault();
			uploadFile.inputElement.classList.remove('active');
		});

		uploadFile.inputElement.addEventListener('drop', (event) => {
			event.preventDefault();
			const file = event.dataTransfer.files[0];
			uploadFile.inputElement.classList.remove('active');

			if (uploadFile.allowedFiles(event, 'drop')) {
				uploadFile.inputElement.files = event.dataTransfer.files;
				uploadFile.fileNameElement.textContent = file.name;
				uploadFile.inputElement.dispatchEvent(changeEvent);
			}
		});

		uploadFile.inputElement.addEventListener('change', function(event) {
			const file = event.target.files[0];
			if (file) {
				if (uploadFile.allowedFiles(event, 'click')) {
					uploadFile.fileNameElement.textContent = file.name;
					if (event.target.value !== '') {
						event.target.classList.remove('wpcf7-not-valid');
						if (event.target.nextElementSibling.nextElementSibling) {
							event.target.nextElementSibling.nextElementSibling.remove();
						}
						// event.target.classList.add('valid');
						uploadFile.fileNameElement.classList.add('changed');
					}
				}
			}
		});
	},

	removeFile: function() {
		if (uploadFile.removeIcon === null) {
			return;
		}
		uploadFile.removeIcon.addEventListener('click', (event) => {
			event.preventDefault();
			uploadFile.inputElement.value = '';
			uploadFile.fileNameElement.classList.remove('changed');
		});
	},

	allowedFiles: function(event, uploadType) {
		if (uploadFile.fileErrorMessage) {
			const _self = event.currentTarget;
			const allowedFileTypes = ['doc', 'docx', 'pdf', 'jpg', 'jpeg', 'png'];
			const fileName = uploadType === 'drop' ? event.dataTransfer.files[0].name : _self.files[0].name;
			const fileExtension = fileName.split('.').pop().toLowerCase();

			if (allowedFileTypes.includes(fileExtension)) {
				uploadFile.fileErrorMessage.classList.remove('active');
				return true; // File is allowed
			} else {
				uploadFile.fileErrorMessage.classList.add('active');
				setTimeout(function() {
					uploadFile.fileErrorMessage.classList.remove('active');
				}, 3000);
				_self.value = '';
				return false; // File is not allowed
			}
		} else {
			return true;
		}
	}
};

export default uploadFile;
